export default __webpack_public_path__ + "static/software-solutions-55152cf38d50ec83ad05360b6b9df716.webp";